<template>
  <OnboardingQuestion :title="question" :disabled="!answer" @next="handleClick">
    <SelectOption v-model="answer" :icon="LocationIcon" value="In my country only">
      In my country only
    </SelectOption>
    <SelectOption v-model="answer" :icon="GlobeIcon" value="Internationally">
      Internationally
    </SelectOption>
    <SelectOption
      v-model="answer"
      :icon="GlobeIcon"
      value="Wherever my work is published"
    >
      Wherever my work is published
    </SelectOption>
  </OnboardingQuestion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { GlobeIcon, LocationIcon } from '@dacr/icons'

import OnboardingQuestion from '@/features/onboarding/components/OnboardingQuestion.vue'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'Where do you want your work legally protected?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Nine] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Nine] = value
  },
})

const handleClick = () => {
  const answers = [answer.value]

  completeStep({ step: 9, question, answers })

  onboardingStore.goToNextStep({ question, answers })
}
</script>
